import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";


import TimelineActu from './components/TimelineActu';
import FriendsList from '../../components/Friends/FriendsList';
import RecentVisitors from './components/RecentVisitors';
import {Button} from "../../components/Button";
import {config} from "../../../config";
import Helmet from "react-helmet";
import {canonical} from "../../../libs/helper";
import createLink from "../../../libs/createLink";
import Advertising from "../../components/Advertising/Advertising";

class FilActu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            responsiveToggle: true,
        }
    }

    render() {

        return (
            <div id="filActu">
                <Helmet>
                    <title>{config.preTitle}Mon réseau{config.postTitle}</title>
                    <link rel="canonical" href={canonical(createLink("actuality"), "", "actuality")} />
                </Helmet>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className="responsive btn-group row">
                        <Button className={"responsive-actu"}
                                active={!this.state.responsiveToggle}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                onClick={() => this.setState({responsiveToggle: false})}
                                content={"Amis"}/>
                        <Button className={"responsive-actu"}
                                active={this.state.responsiveToggle}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                onClick={() => this.setState({responsiveToggle: true})}
                                content={"Fil D'actu"}/>
                    </div>
                    <div className="layout-sidebar">
                        <div
                            className={`sidebar sidebar-friends-newsfeed ${this.state.responsiveToggle ? '' : 'active'}`}>
                            <FriendsList {...this.props} displayTitle={true} displayFriendsSearch={true} isMe={true}
                                         type="timeline" user={this.props.currentUser}/>
                        </div>
                        <div className={`main-wrapper ${this.state.responsiveToggle ? 'active' : ''}`}>
                            <TimelineActu {...this.props} privateFeed={true} isMe={true}
                                          currentUser={this.props.currentUser}
                                          userId={this.props.currentUser._id || 0} load={true} friends={true}/>
                        </div>
                        <div className="sidebar">
                            <RecentVisitors/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FilActu);
